import { IUseFareChangeDetailsResult } from 'obt-common';
import {
  IFareChangeFareBreakupNode,
  FareChangeFareBreakupNodeTypeEnum,
} from 'obt-common/types/Flights/fareChangeBreakupNode';

import Divider from './Divider';
import HeaderContent from './HeaderContent';
import NormalContent from './NormalContent';
import { FareBreakupContainer } from './styles';
import Banner from './Banner';

interface IProps {
  fareChangeDetails: IUseFareChangeDetailsResult;
}

const FareBreakup = ({ fareChangeDetails }: IProps) => {
  const { breakup } = fareChangeDetails;

  const getComponent = (component: IFareChangeFareBreakupNode) => {
    const { type } = component;

    if (type === FareChangeFareBreakupNodeTypeEnum.DIVIDER) {
      return <Divider />;
    }

    switch (component.type) {
      case FareChangeFareBreakupNodeTypeEnum.HEADING:
        return <HeaderContent label={component.label} value={component.value} />;
      case FareChangeFareBreakupNodeTypeEnum.NORMAL:
        return (
          <NormalContent
            label={component.label}
            value={component.value}
            colorVariant={component.colorVariant}
            subText={component.subText}
            strikethroughValue={component.strikethroughValue}
          />
        );
      case FareChangeFareBreakupNodeTypeEnum.BANNER:
        return <Banner value={component.value} />;
      default:
        return null;
    }
  };

  return (
    <FareBreakupContainer>
      {breakup.map((fareComponent) => {
        return getComponent(fareComponent);
      })}
    </FareBreakupContainer>
  );
};

export default FareBreakup;
